import { render, staticRenderFns } from "./HeaderSupporter.vue?vue&type=template&id=2b6ffd36&"
import script from "./HeaderSupporter.vue?vue&type=script&lang=js&"
export * from "./HeaderSupporter.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSupporter.vue?vue&type=style&index=0&id=2b6ffd36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports